<template>
  <!-- 秒杀管理 -->
  <div class="seckill-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="openAddDialog"
            >添加秒杀物品</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-switch
            v-model="seckill_status"
            active-text="开启秒杀"
            inactive-text="关闭秒杀"
            :active-value="1"
            :inactive-value="0"
            @change="changeEvent"
          ></el-switch>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table :data="goodList" v-loading="loading">
        <el-table-column prop="prize_id" label="物品id" align="center">
        </el-table-column>
        <el-table-column prop="prize_num" label="物品数量" align="center">
        </el-table-column>
        <el-table-column prop="tick_num" label="消耗秒杀卷数量" align="center">
        </el-table-column>
        <el-table-column prop="start_time" label="开始时间" align="center">
        </el-table-column>
        <el-table-column prop="end_time" label="结束时间" align="center">
        </el-table-column>
        <el-table-column prop="state" label="状态" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.state === 1">正常</el-tag>
            <el-tag type="danger" v-if="row.state === 2">已删除</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200px">
          <template slot-scope="{ row }">
            <!-- <el-button type="primary" size="small" @click="openEditDialog(row)"
              >编辑</el-button
            > -->
            <el-button type="danger" size="small" @click="deleteEvent(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <!-- <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination> -->
    </div>

    <!-- 弹窗 -->
    <AddSeckillDialog
      :visible="dialogVisible"
      v-model="dialogInfo"
      :typeNum="dialogType"
      @close="dialogVisible = false"
      @refresh="getData"
    ></AddSeckillDialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { api, delApiData, getApiData, postApiData, patchApiData } from '../../http'
import AddSeckillDialog from '../../components/seckill/AddSeckillDialog'
export default {
  components: {
    AddSeckillDialog
  },
  data() {
    return {
      dialogVisible: false,//弹显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      // query: {//查询条件
      //   page: 1,
      // },
      seckill_status: 0,//秒杀开关,0是关闭，1是打开
      dialogType: 1,//弹窗类型 1是添加 2是编辑
      goodList: undefined,//物品列表
      dialogInfo: undefined,//传给弹窗的信息
      dataMeta: undefined,//底部跳转页面
    }
  },
  created() {
    this.getData()
    this.getSwitchStatus()
  },
  methods: {
    getSwitchStatus() {
      //获取控制PK状态按钮
      getApiData('sec_kill_enable')
        .then(res => {
          if (res) {
            res.data ? this.seckill_status = 1 : this.seckill_status = 0
          }
        })
    },
    changeEvent() {
      //控制秒杀状态按钮
      let params = { "black": this.seckill_status ? 1 : 0 }
      patchApiData('sec_kill_enable', params)
        .then(res => {
          this.$message.success('操作成功！')
        }).catch(err => {
          //关闭/打开红包按钮失败，还原标志
          this.seckill_status = this.seckill_status ? 0 : 1
        })

    },
    getData() {
      this.loading = true
      getApiData('secondKill')
        .then(res => {
          this.goodList = res.data
          //设置底部导航条数据
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })

    },
    openAddDialog() {
      //添加秒杀物品
      this.dialogInfo = undefined
      this.dialogType = 1
      this.dialogVisible = true
    },
    openEditDialog(rowInfo) {
      //编辑行
      this.dialogInfo = JSON.parse(JSON.stringify(rowInfo))
      this.dialogType = 2
      this.dialogVisible = true
    },
    deleteEvent(rowInfo) {
      //删除行
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delApiData(`secondKill/${rowInfo.id}`).then(res => {
          this.$message.success('删除成功')
          this.getData()
        })
      }).catch(() => {

      })
    },
    // handlePageChange(page) {
    //   //页面底部跳转页面
    //   this.query.page = page
    //   this.getData();
    // },
  }

}
</script>
<style lang="less" scoped>
</style>